function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100 0H0V80H100V0ZM16.2841 11H45.7386V29.4091C45.7386 44.4432 35.3068 60.3977 25.4886 68.9886L8 60.0909C12.2955 52.7273 16.2841 43.5227 16.2841 29.4091V11ZM54.3295 11H83.7841V29.4091C83.7841 44.4432 73.3523 60.3977 63.5341 68.9886L46.0455 60.0909C50.3409 52.7273 54.3295 43.5227 54.3295 29.4091V11Z"
});

function SvgQuotesBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Quotes_quoteMark__341RR",
    viewBox: "0 0 100px 80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesBottom);
export default __webpack_public_path__ + "static/media/quotes-bottom.ab52e2e0.svg";
export { ForwardRef as ReactComponent };